import React, { useRef } from 'react'
import { ContentAttach, DocumentBasic, HelpTip, MenuMore, PersonRemove, ThingFlag } from '@fs/zion-icon'
import { IconButton, Button, useOverlay, QuickGlanceOverlay, FlowGrid, DescriptionTooltip } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { SocialMenu } from '@fs/zion-social'

export default function HiddenMenu({
  loading,
  handleClickRecordDetails,
  personId,
  sharable,
  notAPerson = false,
  handleNotAPerson = () => {},
  transcriptionError = false,
  handleTranscriptionError = () => {},
  attachToTree = false,
  recordDetails = false,
  welcomeOverlay,
  social = false,
}) {
  const [t] = useTranslation()
  const menuOverlay = useOverlay()
  const menuRef = useRef()
  return (
    <>
      <IconButton
        title={t('navigation.menu-button', 'More Tools')}
        Icon={MenuMore}
        onClick={() => menuOverlay.handleClick()}
        color="gray"
        size="md"
        ref={menuRef}
      />
      <QuickGlanceOverlay {...menuOverlay} placement="start" targetRef={menuRef}>
        <FlowGrid columnCount={1} orientation="vertical" gutters="pico">
          {notAPerson && (
            <DescriptionTooltip
              target={
                <Button
                  Icon={PersonRemove}
                  emphasis="low"
                  fullWidth
                  onClick={() => {
                    handleNotAPerson({}, 'WORD')
                  }}
                >
                  {t('report-error-overlay.not-a-person-button', 'Not A Person')}
                </Button>
              }
              label="NotAPerson"
              description={t(
                'navigation.not-a-person-tooltip',
                'Sometimes the computer identifies text as a name but it may actually be a note from the census taker. Hint: Common text such as "Vacant", "No One Home", etc.'
              )}
            />
          )}
          {welcomeOverlay && (
            <Button
              Icon={HelpTip}
              onClick={welcomeOverlay.handleClick}
              data-testid="instructions-modal"
              linkName="Instructions Modal"
            >
              {t('navigation.instructions-button', 'Instructions')}
            </Button>
          )}
          {recordDetails && personId && (
            <Button
              disabled={loading}
              Icon={DocumentBasic}
              title={t('navigation.details-button', 'Record Details')}
              onClick={() => handleClickRecordDetails()}
              data-testid="record-details"
              linkName="Record Details"
            >
              {t('navigation.details-button', 'Record Details')}
            </Button>
          )}
          {attachToTree && personId && (
            <Button
              disabled={loading}
              Icon={ContentAttach}
              title={t('attach.header', 'Attach To Tree')}
              onClick={() => {
                const ark = `/ark:/61903/${personId}`
                window.open(`/search/linker?ark=${encodeURIComponent(ark)}&sourceType=rii`)
              }}
              data-testid="attach-to-tree"
              linkName="Attach To Tree"
            >
              {t('attach.header', 'Attach To Tree')}
            </Button>
          )}
          {transcriptionError && (
            <Button Icon={ThingFlag} emphasis="low" fullWidth onClick={handleTranscriptionError}>
              {t('report-error-overlay.error-button', 'Transcription Error')}
            </Button>
          )}
          {social && <SocialMenu disabled={loading} sharable={sharable} buttonEmphasis="low" />}
        </FlowGrid>
      </QuickGlanceOverlay>
    </>
  )
}
